(function () {
    "use strict";

    angular
        .module("stValidators", [])
        .directive("stUnique", stUniqueDirective)
        .directive("stInvalid", stInvalidDirective)
        .directive("stIpAddress", stIpAddressDirective)
        .directive("stGreaterThan", stGreaterThanDirective)
        .directive("stLessThan", stLessThanDirective)
        .directive("stEqual", stEqualDirective)
        .directive("stMinDate", minDateDirective)
        .directive("stMaxDate", maxDateDirective)
        .directive("stMultiple", stMultipleDirective);

    /**
     * St Unique
     * 
     * Error value: unique
     * 
     * Checks if a value is unique or not.
     * Requires a function that returns true if the given value exits. Otherwise, returns false.
     */
    stUniqueDirective.$inject = ["$q"];

    function stUniqueDirective($q) {
        return {
            restrict: "A",
            require: "?ngModel",
            scope: {
                stUnique: "&"
            },
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                ctrl.$asyncValidators.unique = function (modelValue, viewValue) {
                    const value = modelValue || viewValue;

                    if (ctrl.$pristine || ctrl.$isEmpty(value))
                        return $q.resolve();

                    return scope.stUnique({ value: value })
                        .then(result => {
                            if (result) {
                                return $q.reject("exists");
                            }
                            return true;
                        });
                };
            }
        };
    }



   /**
     * St Invalid
     * 
     * Error value: invalid
     * 
     * Checks if a value is invalid or not.
     * Requires a function that returns true if the given value is invalid. Otherwise, returns false.
     * This function should also return an error message that can be used to notify users
     */

    stInvalidDirective.$inject = ["$q"];

    function stInvalidDirective($q) {
        return {
            restrict: "A",
            require: "?ngModel",
            scope: {
                stInvalid: "&"
            },
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                ctrl.$asyncValidators.invalid = function (modelValue, viewValue) {
                    const value = modelValue || viewValue;

                    const defer = $q.defer();

                    if (ctrl.$pristine || ctrl.$isEmpty(value)) {
                        defer.resolve();
                        return defer.promise;
                    }

                    scope.stInvalid({ value: value })
                        .then(invalid => {
                            if (invalid) {
                                defer.reject();
                            } else {
                                defer.resolve();
                            }
                            return defer.promise;
                        });

                    return defer.promise;
                };
            }
        };
    }



    /**
     * St Ip Address
     * 
     * Error value: ipAddress
     * 
     * Checks if that value is a valid IPv4 address
     */
    function stIpAddressDirective() {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                const regexIpAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;

                ctrl.$validators.ipAddress = function (modelValue, viewValue) {
                    const value = modelValue || viewValue;
                    return (ctrl.$isEmpty(value) || value.match(regexIpAddress) != null);
                };
            }
        };
    }


    /**
     * St Greater Than
     * 
     * Error value: greaterThan
     * 
     * Checks if a value is greater than the given value
     * 
     * Note: ng-min is greater than or equal (>=)
     */
    function stGreaterThanDirective() {

        function parseNumberAttrVal(val) {
            if (angular.isDefined(val) && !angular.isNumber(val)) {
                val = parseFloat(val);
            }
            return !isNaN(val) ? val : undefined;
        }

        return {
            restrict: "A",
            require: "?ngModel",
            link: function(scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var minVal;

                attr.$observe("stGreaterThan",
                    function(val) {
                        minVal = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                scope.$watch(attr["stGreaterThan"],
                    function(val) {
                        minVal = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                ctrl.$validators.greaterThan = function(value) {
                    return ctrl.$isEmpty(value) || angular.isUndefined(minVal) || value > minVal;
                };
            }
        };
    }


    /**
    * St Less Than
    * 
    * Error value: lessThan
    * 
    * Checks if a value is less than the given value
    * 
    * Note: ng-max is less than or equal (<=)
    */
    function stLessThanDirective() {

        function parseNumberAttrVal(val) {
            if (angular.isDefined(val) && !angular.isNumber(val)) {
                val = parseFloat(val);
            }
            return !isNaN(val) ? val : undefined;
        }

        return {
            restrict: "A",
            require: "?ngModel",
            link: function(scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var maxVal;

                attr.$observe("stLessThan",
                    function(val) {
                        maxVal = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                scope.$watch(attr["stLessThan"],
                    function(val) {
                        maxVal = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                ctrl.$validators.lessThan = function(value) {
                    return ctrl.$isEmpty(value) || angular.isUndefined(maxVal) || value < maxVal;
                };
            }
        };
    }


    /**
     * St Equal
     * 
     * Error value: equal
     * 
     * Checks if a value is equal to the given value
     */
    function stEqualDirective() {
        return {
            require: "?ngModel",
            link: (scope, elm, attr, ctrl) => {
                if (!ctrl) return;

                var equalValue = attr["stEqual"];

                attr.$observe("stEqual", function (val) {
                    equalValue = val;
                    ctrl.$validate();
                });

                ctrl.$validators.equal = (modelValue, viewValue) => {
                    const value = modelValue || viewValue;
                    return (ctrl.$isEmpty(value) || value.toUpperCase() === equalValue.toUpperCase());
                };
            }
        };
    }


    /**
     * St Min Date
     * 
     * Error value: minDate
     * 
     * Checks if a date is greater than or equal to the given date
     * It is like ng-min but for date values
     * It is useful for date ranges to make sure that an end date is >= to a start date
     * 
     */
    function minDateDirective() {
        function parseDate(val) {
            if (angular.isDefined(val) && val !== null) {
                val = new Date(val);
            }
            return !isNaN(val) && angular.isDate(val) ? val : undefined;
        }

        return {
            restrict: "A",
            require: "?ngModel",
            link: function(scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var minimumDate;

                attr.$observe("stMinDate",
                    function(val) {
                        minimumDate = parseDate(val);
                        ctrl.$validate();
                    });

                scope.$watch(attr["stMinDate"],
                    function(val) {
                        minimumDate = parseDate(val);
                        ctrl.$validate();
                    });

                ctrl.$validators.minDate = function(value) {
                    if (ctrl.$isEmpty(value) || angular.isUndefined(minimumDate))
                        return true;

                    value = parseDate(value);

                    return angular.isUndefined(value) || value >= minimumDate;
                };
            }
        };
    }


    /**
     * St Max Date
     * 
     * Error value: maxDate
     * 
     * Checks if a date is less than or equal to the given date
     * It is like ng-max but for date values
     * It is useful for date ranges to make sure that a start date is <= to an end date
     * 
     */
    function maxDateDirective() {
        function parseDate(val) {
            if (angular.isDefined(val) && val !== null) {
                val = new Date(val);
            }
            return !isNaN(val) && angular.isDate(val) ? val : undefined;
        }

        return {
            restrict: "A",
            require: "?ngModel",
            link: function(scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var maximumDate;

                attr.$observe("stMaxDate",
                    function(val) {
                        maximumDate = parseDate(val);
                        ctrl.$validate();
                    });

                scope.$watch(attr["stMaxDate"],
                    function(val) {
                        maximumDate = parseDate(val);
                        ctrl.$validate();
                    });

                ctrl.$validators.maxDate = function(value) {
                    if (ctrl.$isEmpty(value) || angular.isUndefined(maximumDate))
                        return true;

                    value = parseDate(value);

                    return angular.isUndefined(value) || value <= maximumDate;
                };
            }
        };
    }


    /**
    * St Multiple
    * 
    * Error value: multiple
    * 
    * @return {boolean} Checks if a value is a multiple of the given value
    */
    function stMultipleDirective() {

        function parseNumberAttrVal(val) {
            if (angular.isDefined(val) && !angular.isNumber(val)) {
                val = parseFloat(val);
            }
            return !isNaN(val) ? val : undefined;
        }

        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var multiple;

                attr.$observe("stMultiple",
                    function (val) {
                        multiple = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                scope.$watch(attr["stMultiple"],
                    function (val) {
                        multiple = parseNumberAttrVal(val);
                        ctrl.$validate();
                    });

                ctrl.$validators.multiple = (modelValue, viewValue) => {
                    const value = modelValue || viewValue;
                    return ctrl.$isEmpty(value) || angular.isUndefined(multiple) || value % multiple === 0;
                };
            }
        };
    }

})();